import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios"; // For API calls
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import AddKeyValue from "./SellerComp/AddKeyValue";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import EditListingNavbar from "./SellerComp/EditListingNavbar";
import { Save,} from "react-feather";

const ListingTwo = () => {
  const { listing_id } = useParams(); // Get listing_id from the URL
  const [keyValuePairs, setKeyValuePairs] = useState([]); // State to store key-value pairs
  const [loading, setLoading] = useState(true); // State to track loading status
  const [error, setError] = useState(null); // State to handle errors
  const [editData, setEditData] = useState(null); // State for edit data
  const [showModal, setShowModal] = useState(false); // State for modal visibility

  useEffect(() => {
    console.log("Listing ID from URL:", listing_id);

    // Fetch key-value pairs based on listing_id
    const fetchKeyValuePairs = async () => {
      try {
        const response = await axios.get(`${baseurl}/seller/key-value/${listing_id}`);
        console.log("Fetched Data:", response.data);
        setKeyValuePairs(response.data.data); // Set the fetched data
      } catch (err) {
        console.error("Error fetching key-value pairs:", err);
        setError("Please Add Specifications using Add Specification Button.");
      } finally {
        setLoading(false); // Stop loading indicator
      }
    };

    if (listing_id) fetchKeyValuePairs(); // Fetch only if listing_id is available
  }, [listing_id]);

  // Handle delete action
  const handleDelete = async (id) => {
    // Show SweetAlert2 confirmation before deletion
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
  
    // If the user confirms the deletion
    if (result.isConfirmed) {
      try {
        await axios.delete(`${baseurl}/seller/delete-key-value/${id}`);
        setKeyValuePairs((prev) => prev.filter((pair) => pair.id !== id)); // Remove from UI
        Swal.fire("Deleted!", "Your key-value pair has been deleted.", "success"); // Show success message
      } catch (err) {
        console.error("Error deleting key-value pair:", err);
        Swal.fire("Error!", "Failed to delete key-value pair.", "error"); // Show error message
      }
    }
  };

  // Handle edit action
  const handleEdit = (pair) => {
    setEditData(pair); // Set data for editing
    setShowModal(true); // Show modal
  };

  // Handle update action
  const handleUpdate = async () => {
    try {
      const { id, key, value } = editData; // Get updated values
      await axios.put(`${baseurl}/seller/update-key-value/${id}`, { key, value });
  
      setKeyValuePairs((prev) =>
        prev.map((pair) => (pair.id === id ? { ...pair, key, value } : pair))
      ); // Update UI
      setShowModal(false); // Close modal
  
      // Show success message using SweetAlert2
      Swal.fire({
        title: "Success!",
        text: "Key-value pair updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
  
    } catch (err) {
      console.error("Error updating key-value pair:", err);
      alert("Failed to update key-value pair.");
    }
  };

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">

                <EditListingNavbar/>
                <div className="reviewcls text-start">
                  
                  <div className="row g-2">
                    <div className="col-md-6">
                    <h4 className="selh1">Additional Details</h4>
                    </div>
                    <div className="col-md-6 text-end">
                    <AddKeyValue />
                    </div>
                      {/* <div className="col-12">
                        <AddKeyValue />
                      </div> */}
 
                    </div>

                  <hr />

                  {/* Loading and Error Handling */}
                  {loading && <div class="d-flex justify-content-center align-items-center ">
  <div class="spinner-border text-danger" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>}
                  {error && 

                  <div>
                    <div className="text-center message1">
                    {error}
                    </div>
                     
                  </div>
                  
                  }

                  {/* Display Key-Value Pairs in a Table */}
                  {!loading && !error && keyValuePairs.length > 0 && (
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          {/* <th>ID</th> */}
                          <th>Key</th>
                          <th>Value</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {keyValuePairs.map((pair) => (
                          <tr key={pair.id}>
                            {/* <td>{pair.id}</td> */}
                            <td>{pair.key}</td>
                            <td>{pair.value}</td>
                            <td>
                              <button
                                className="btn btn-warning btn-sm me-2"
                                onClick={() => handleEdit(pair)}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDelete(pair.id)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}

                  {/* Show Message if No Key-Value Pairs are Found */}
                  {!loading && !error && keyValuePairs.length === 0 && (
                    <p>No key-value pairs found for this listing.</p>
                  )}



 

                  {/* Modal for Editing */}
                  {showModal && (
                    <div className="modal show d-block showwq" tabIndex="-1">
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Edit Key-Value Pair</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setShowModal(false)}
                            ></button>
                          </div>
                          <div className="modal-body">
                            <form>
                              <div className="mb-3">
                                <label htmlFor="editKey" className="form-label">
                                  Key
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="editKey"
                                  value={editData.key}
                                  onChange={(e) =>
                                    setEditData((prev) => ({ ...prev, key: e.target.value }))
                                  }
                                />
                              </div>
                              <div className="mb-3">
                                <label htmlFor="editValue" className="form-label">
                                  Value
                                </label>
                                <textarea
                                  className="form-control"
                                  id="editValue"
                                  value={editData.value}
                                  onChange={(e) =>
                                    setEditData((prev) => ({ ...prev, value: e.target.value }))
                                  }
                                ></textarea>
                              </div>
                            </form>
                          </div>
                          <div className="modal-footer">
                            
                            <button
                              type="button"
                              className="btn submitbtnn me-2"
                              onClick={handleUpdate}
                            >
                             <Save size={17}/> Save Changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ListingTwo;
